/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：256
 */

var r = require(/* 477 */"../1720/477")
var /* [auto-meaningful-name] */Math$min = Math.min
module.exports = function (e) {
  return e > 0 ? Math$min(r(e), 9007199254740991) : 0
}
